module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/md5.js/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 215
// module chunks = 42